import { useState } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useUserCanEditFarm, useUserRole } from '../../utils/hooks';
import CreateTemplateFromCrop from './CreateTemplateFromCrop';
import RevertToTemplate from './RevertToTemplate';
import DuplicateCrop from './DuplicateCrop';

const CropActionsDropdown = ({
  mutateAndSetState,
  resource,
  refetchQuery,
  loading,
  ...props
}) => {
  const { farmId } = useParams();
  const userCanEditFarm = useUserCanEditFarm(farmId);
  const { isSuperadmin } = useUserRole();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((open) => !open);
  const id = resource?.id;
  if (!id) return null;
  const showCreateTeamTemplate = resource.farm.team?.allowedActions.canEdit;
  const showCreatePublicTemplate = isSuperadmin;
  const showDuplicateCrop = userCanEditFarm;
  const showRevertToTemplate = userCanEditFarm && resource.templateId;
  if (
    !showCreateTeamTemplate &&
    !showCreatePublicTemplate &&
    !showDuplicateCrop &&
    !showRevertToTemplate
  ) {
    return null;
  }

  return (
    <RevertToTemplate
      id={id}
      mutateAndSetState={mutateAndSetState}
      refetchQuery={refetchQuery}
      className="mr-2"
      loading={loading}
    >
      {({ renderRevertToTemplateItem, renderRevertToTemplateModal }) => (
        <>
          {showRevertToTemplate && renderRevertToTemplateModal()}
          <Dropdown
            isOpen={dropdownOpen}
            toggle={toggle}
            className="d-inline mr-2"
          >
            <DropdownToggle caret disabled={loading} {...props}>
              Crop Actions
            </DropdownToggle>
            <DropdownMenu container="body">
              {showDuplicateCrop && (
                <DuplicateCrop id={id} mutateAndSetState={mutateAndSetState} />
              )}
              {showRevertToTemplate && renderRevertToTemplateItem()}
              {showCreatePublicTemplate && (
                <CreateTemplateFromCrop
                  id={id}
                  name={resource?.name}
                  mutateAndSetState={mutateAndSetState}
                  publicTemplate
                />
              )}
              {showCreateTeamTemplate && (
                <CreateTemplateFromCrop
                  id={id}
                  name={resource?.name}
                  mutateAndSetState={mutateAndSetState}
                />
              )}
            </DropdownMenu>
          </Dropdown>
        </>
      )}
    </RevertToTemplate>
  );
};

export default CropActionsDropdown;
